import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/WeChat_ma.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8bbcf5e2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "foot"
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "position": "relative"
  }
};
var _hoisted_3 = {
  class: "block1"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text1"
  }, "相关产品", -1);
});

var _hoisted_5 = {
  style: {
    "margin-left": "85px"
  }
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text1"
  }, "购买渠道", -1);
});

var _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div style=\"margin-left:85px;\" data-v-8bbcf5e2><div class=\"text1\" data-v-8bbcf5e2>服务中心</div><div class=\"text2\" data-v-8bbcf5e2>用户指南</div></div><div style=\"margin-left:85px;\" data-v-8bbcf5e2><div class=\"text1\" data-v-8bbcf5e2>联系我们</div><div class=\"text2\" data-v-8bbcf5e2>邮箱：business@bcepd.cn </div><div class=\"text2\" data-v-8bbcf5e2>电话：19906732855</div><div class=\"text2\" data-v-8bbcf5e2>浙江省杭州市富阳区银湖街道 <br data-v-8bbcf5e2> 富闲路9号银湖创新中心1号楼13层</div></div><div class=\"foot_img\" data-v-8bbcf5e2><img src=\"" + _imports_0 + "\" class=\"img\" data-v-8bbcf5e2></div>", 3);

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "foot_text"
  }, " CopyRight @ 2022 杭州百城智联科技有限公司 浙ICP备17033259号-2 ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
    class: "text2",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.gotoBaicheng && _ctx.gotoBaicheng.apply(_ctx, arguments);
    })
  }, "百城官网"), _createElementVNode("div", {
    class: "text2",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.gotoQimingxing && _ctx.gotoQimingxing.apply(_ctx, arguments);
    })
  }, "启明星官网"), _createElementVNode("div", {
    class: "text2",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.gotoHuiben && _ctx.gotoHuiben.apply(_ctx, arguments);
    })
  }, "绘本通官网")]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", {
    class: "text2",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.gotoTM && _ctx.gotoTM.apply(_ctx, arguments);
    })
  }, "天猫旗舰店"), _createElementVNode("div", {
    class: "text2",
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.gotoJD && _ctx.gotoJD.apply(_ctx, arguments);
    })
  }, "京东自营店")]), _hoisted_7]), _hoisted_10]);
}